import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { rm } from 'utils';
import { Button } from 'components/Button';
import { fetchSortedPage } from 'views/ProductlistPage/actions';
import Drawer from 'components/Shared/Drawer';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { SortOrder } from 'models/SortOrder';
import { getSortOrders, getSelectedSortOrder } from 'views/ProductlistPage/selectors';
import { FilterButton } from 'components/Filter/themes/BGH/filterButton';
import { FilterHeader } from './filterHeader';
import { PageState } from 'models/PageState';
import styles from './styles.scss';

interface Props {
  className: string;
}

const sortOrderSelector = (state: PageState) => getSortOrders(state.currentPage);
const selectedSortOrderSelector = (state: PageState) => getSelectedSortOrder(state.currentPage);

export const Sort = ({ className }: Props) => {
  const [isOpen, setOpen] = useState(false);
  const open = () => setOpen(true);
  const close = () => setOpen(false);

  const isMobile = useSelector(isMobileSelector);
  const selectedSortOrder = useSelector(selectedSortOrderSelector);
  const _sortOrders = useSelector(sortOrderSelector);
  const sortOrders = _sortOrders.map(sortOrder => ({
    value: sortOrder,
    label: rm(`sortorder_${SortOrder[sortOrder].toLowerCase()}`)
  }));

  const dispatch = useDispatch();
  const setSortOrder = (sortOrder: SortOrder) => dispatch(fetchSortedPage(sortOrder));

  const onSort = (sortOrder: SortOrder) => () => {
    void setSortOrder(sortOrder);
    close();
  };

  return (
    <>
      <FilterButton className={className} onClick={open}>
        <span>{rm('filter_sort_button')}</span>
      </FilterButton>

      <Drawer
        className={styles.drawer}
        padding="none"
        side="right"
        appearance="header"
        width={isMobile ? 'full' : 'default'}
        onClose={close}
        transparent={isMobile || undefined}
        isOpen={isOpen}
      >
        <div className={styles.header}>
          <h3>{rm('filter_sort_drawer_header')}</h3>
        </div>

        <div className={styles.body}>
          {sortOrders.map(({ value, label }) => (
            <FilterHeader
              key={value}
              className={cn({ [styles.selectedSortOrder]: value === selectedSortOrder })}
              displayName={label}
              onClick={onSort(value)}
              border
            />
          ))}
        </div>

        <div className={styles.footer}>
          <Button onClick={close} className={styles.filterButton} appearance="tertiary">
            {rm('filter_sort_drawer_close_button')}
          </Button>
        </div>
      </Drawer>
    </>
  );
};
